












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { BFormDatepicker } from "bootstrap-vue";
import moment from "moment-timezone";
import {
    AppointmentRequest, Form, FormQuestion
} from "@/store/modules/types";
import FormViewer from "@/components/FormViewer.vue";
import Swal from "sweetalert2";


@Component({
    components: {
        BFormDatepicker,
        FormViewer
    }
})
export default class AppointmentCalendarRequestPage extends Vue {
    defaultAppt = (): AppointmentRequest => ({
        main: {
            calendarId: "",
            reasonId: "",
            priorityId: "",
            typeId: "APT",
            date: this.today,
            time: "",
            sessionId: "",
            patient: {
                id: null,
                firstName: "",
                lastName: "",
                lastName2: "",
                birth: {
                    year: "",
                    years: [],
                    month: "",
                    monthDays: [],
                    day: "",
                    date: "",
                },
                phone: "",
                insurer: {
                    id: "",
                    memberId: "",
                },
                EMR_ID: "",
                email: "",
            },
            lang: "",
            statusId: "1",
            duration: 0,
        },
        prereqs: {
            list: [],
            selected: null,
        },
        files: [],
        comment: "",
    });
    agreementContent: string = "<p class='text-center'>Loading agreement...</p>";
    loading = false;
    submitted = false;
    //form = this.initialForm();
    calendar = {};
    urlName = this.$route.params.c;
    appt = this.defaultAppt();
    prereqForm = {
        prereq: {},
        form: {} as Form,
        questions: Array<FormQuestion>(),
    };
    doctor = {
        name: "",
        specialty: "",
        experience: "",
        address: "",
        phone: "",
        email: "",
        profilePicture: "",
        bio: "",
        facility: ""
    };
    requestTypes: any = []; //["New Patient Appointment", "Follow-up Appointment", "Consultation", "Urgent Visit"];
    selectedType: any = { "description": null };
    timeSlots = ["9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "2:00 PM", "2:30 PM", "3:00 PM"];
    sessions = [];
    slotsLimit: number = 5;
    insurers: any = [];
    dobParts = {
        day: "" as string | number,
        month: "" as string | number,
        year: "" as string | number
    };
    months: string[] = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    get today(): string {
        const maxDays = this.calendar["apptRequestMaxDays"] || 0;


        return moment()
            .add(maxDays, "days")
            .format("YYYY-MM-DD");

    }

    async getCalendar() {
        this.$store.commit("main/SET_LOADING", true);
        try {
            this.calendar = await this.$store.dispatch("schedule/getCalendarByUrlName", this.urlName);
            if (!this.calendar) {
                this.$router.push({
                    name: 'request'
                });
            }

            this.appt.main.date = this.getNextAvailableDate();
            this.calendar["apptDateHeader"] = this.parseJSON(this.calendar["apptDateHeader"]);
            this.calendar["longDescription"] = this.parseJSON(this.calendar["longDescription"]);
            this.doctor.name = this.calendar["name"];
            this.doctor.specialty = this.calendar["specialty"];
            //this.doctor.address = this.calendar["addrLine1"] + " " + this.calendar["addrLine2"];
            this.doctor.address = [
                this.calendar["addrLine1"],
                this.calendar["addrLine2"],
                this.calendar["city"],
                this.calendar["state"],
                this.calendar["zip"]
            ].map(v => v?.trim()).filter(v => v).join(", ");
            this.doctor.phone = this.calendar["phone"];
            this.doctor.email = (this.calendar["email"] || "").split(";")[0];
            this.doctor.bio = this.parseJSON(this.calendar["shortBio"]);//JSON.parse(this.calendar["shortBio"]);
            this.doctor.experience = this.calendar["yearsExperience"] ? this.calendar["yearsExperience"] : "";
            this.doctor.facility = this.calendar["entityName"];
            this.$i18n.locale = this.calendar["lang"].toLowerCase();
            this.appt.main.lang = this.currentLang;
            if (this.calendar["photoContentId"]) {

                this.doctor.profilePicture = this.getLogoURL(this.calendar["photoContentId"]);

            }
            if (this.calendar["autoApprove"]) {
                this.appt.main.statusId = "2";
            }

            this.getTimes();
            this.getSesions();

            var insurersByEntity = this.calendar["insurersByEntity"];
            this.appt.main.calendarId = this.calendar["id"];

            if (insurersByEntity) {
                this.getInsurers();
            } else {
                this.getInsurers(this.appt.main.calendarId);
            }

            this.getReasons(this.appt.main.calendarId);
        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }

    async getTimes() {
    try {
        if (!this.calendar["showTimes"]) {
            this.timeSlots = [];
            return;
        }

        this.slotsLimit = 5;

        const calendarId = this.calendar["id"];
        const date = this.appt.main.date;
        const tz = this.calendar["timezone"];

        const bookingBuffer = this.requestTypes.find(
            r => r.id == this.appt.main.reasonId
        )?.bookingBuffer;

        const now = moment()
            .tz(tz)
            .add(bookingBuffer || 0, "minutes");

        const times = await this.$store.dispatch(
            "schedule/getRequestCalendarTimes",
            {
                calendarId,
                date,
            }
        );

        // Aplicar filtros actuales
        let filteredSlots = times.filter(t => {
            if (t.disabled) return false;

            const slotTime = moment.tz(
                `${date} ${t.time}`,
                "YYYY-MM-DD HH:mm:ss",
                tz
            );

            return slotTime.isAfter(now);
        });

        // Duración del reason
        const reasonDuration = this.appt.main.duration || 0;

        // Duración de cada slot del calendario
        const slotDuration = this.calendar["apptDuration"] || 30;

        // Cuántos slots continuos se necesitan
        const requiredSlots = Math.ceil(
            reasonDuration / slotDuration
        );

        // Crear lookup rápido por time
        const slotMap = new Map();

        filteredSlots.forEach(slot => {
            slotMap.set(slot.time, slot);
        });

        // Validar continuidad
        filteredSlots = filteredSlots.map(slot => {
            const startTime = moment.tz(
                `${date} ${slot.time}`,
                "YYYY-MM-DD HH:mm:ss",
                tz
            );

            let hasContinuousSlots = true;

            for (let i = 1; i < requiredSlots; i++) {
                const nextTime = startTime
                    .clone()
                    .add(i * slotDuration, "minutes")
                    .format("HH:mm:ss");

                if (!slotMap.has(nextTime)) {
                    hasContinuousSlots = false;
                    break;
                }
            }

            return {
                ...slot,
                disabled: !hasContinuousSlots
            };
        });

        this.timeSlots = filteredSlots;

    } catch (error) {
        console.log(error);
    }
}

    async getTimesBK20260511() {
        try {
            if (!this.calendar["showTimes"]) {
                this.timeSlots = [];
                return;
            }

            this.slotsLimit = 5;
            var calendarId = this.calendar["id"];
            var date = this.appt.main.date;
            const tz = this.calendar["timezone"];
            const bookingBuffer = this.requestTypes.find(r => r.id == this.appt.main.reasonId)?.bookingBuffer;
            const now = moment().tz(tz).add(bookingBuffer || 0, 'minutes');

            const times = await this.$store.dispatch("schedule/getRequestCalendarTimes", {
                calendarId,
                date,
            });

            this.timeSlots = times.filter(t => {
                if (t.disabled) return false;

                const slotTime = moment.tz(
                    `${date} ${t.time}`,
                    "YYYY-MM-DD HH:mm:ss",
                    tz
                );

                return slotTime.isAfter(now);
            });
        } catch (error) {
            console.log(error);
        }
    }

    async getSesions() {
        try {

            if (!this.calendar["showSession"]) {
                this.sessions = [];
                return;
            }

            const calendarId = this.calendar["id"];
            const date = this.appt.main.date;
            const tz = this.calendar["timezone"];

            const now = moment().tz(tz);
            const today = now.format("YYYY-MM-DD");

            const sessions = await this.$store.dispatch(
                "schedule/getRequestCalendarSessions",
                { calendarId, date }
            );

            this.sessions = sessions.filter(s => {
                if (s.disabled === "1") return false;

                // 👉 Si NO es hoy, no validar hora
                if (date !== today) return true;

                const end = moment.tz(
                    `${date} ${s.endTime.trim()}`,
                    "YYYY-MM-DD h:mmA",
                    tz
                );

                // 👉 Solo validar si ya terminó la sesión
                return end.isAfter(now);
            });

        } catch (error) {
            console.log(error);
        }
    }
    async getInsurers(calendarId?: any) {
        try {
            if (calendarId) {

                this.insurers = await this.$store.dispatch(
                    "schedule/getRequestCalendarInsurers",
                    calendarId
                );
                return;
            }

            this.insurers = await this.$store.dispatch(
                "schedule/getRequestEntityInsurers",
                this.calendar["entity"]
            );
        } catch (error) {
            console.log(error);
        }
    }

    async getReasons(calendarId: string) {
        try {
            this.requestTypes = await this.$store.dispatch(
                "schedule/getRequestCalendarReasons",
                calendarId
            );
        } catch (error) {
            console.log(error);
        }
    }

    async getPreReqs() {
        this.$store.commit("main/SET_LOADING", true);
        const calendarId = this.appt.main.calendarId;
        const apptTypeId = this.appt.main.typeId;
        try {
            this.appt.prereqs.list = await this.$store.dispatch(
                "schedule/getRequestApptPreReqList",
                {
                    calendarId,
                    apptTypeId
                }
            );
        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }

    async getDates(calendarId: string) {
        try {
            this.calendar["Dates"] = await this.$store.dispatch(
                "schedule/getCalendarDates",
                calendarId
            );
        } catch (error) {
            console.log(error);
        }
    }

    loadTimeSlots() {
        this.getTimes();
        this.getSesions();
    }

    async loadAgreement() {
        try {
            const response = await fetch(`/agreement_${this.currentLang}.html`);
            if (response.ok) {
                this.agreementContent = await response.text();
            } else {
                this.agreementContent = "Error loading terms. Please contact support.";
            }
        } catch (error) {
            console.error("Error loading agreement:", error);
            this.agreementContent = "Agreement file not found.";
        }
    }

    async submitRequest() {
        this.$bvModal.hide('modal-terms');
        this.loading = true;
        this.$store.commit("main/SET_LOADING", true);
        try {
            await this.$store.dispatch("schedule/saveRequestAppt", this.appt);
            this.submitted = true;
            this.scrollToTop();
        }catch (error) {

            const err = error as any;

        console.log("Status:", err?.response?.status);
        console.log("Response:", err?.response?.data);
        console.log("Full Error:", error);

        const code = err?.response?.data?.Result;

        if (code === "SLOT_UNAVAILABLE") {
            Swal.fire({
    icon: 'warning',
    title: this.$t('Time Slot Unavailable').toString(),
    text: this.$t('Sorry, the selected appointment time is no longer available. Please select a different time slot or session.').toString(),
    confirmButtonText: this.$t('OK').toString()
});
    this.appt.main.time="";
    this.appt.main.sessionId="";
     this.loadTimeSlots();
     return;
        }

         Swal.fire({
        icon: 'error',
        title: this.$t('Error').toString(),
        text: this.$t(
            'We’re sorry, an unexpected error occurred while submitting the request. Please try again.'
        ).toString(),
        confirmButtonText: this.$t('OK').toString()
    });

    } finally {
            this.loading = false;
            this.$store.commit("main/SET_LOADING", false);
        }
    }

    openTermsModal() {

        let isPrereqInvalid = false;
        this.appt.prereqs.list.forEach((prereq: any) => {
        if (!prereq.optional  && (prereq.typeId === 'BIN' || prereq.typeId === 'PIC')) {
            if (!prereq.fileObject && !prereq.fileName) {
                this.$set(prereq, 'invalid', true);
                isPrereqInvalid = true;
            }
        }else if (!prereq.optional && (prereq.typeId === 'FRM' )) {
            
    const isValid = this.validateForm(prereq);

    if (!isValid) {
        isPrereqInvalid = true;
    }
        }
    });

    // Si falta algún documento, frenamos el flujo y avisamos al usuario
    if (isPrereqInvalid) {
        this.$nextTick(() => {
            const element = this.$refs.prereqsSection as HTMLElement;
            if (element) {
                element.scrollIntoView({ 
                    behavior: 'smooth', // Desplazamiento fluido y elegante
                    block: 'center'     // Centra la sección en la pantalla del usuario
                });
            }
        });
        return; 
    }

        this.loadAgreement();
        this.$bvModal.show('modal-terms');
    }

    scrollToTop() {
        this.$nextTick(() => {
            const container = this.$refs.scrollContainer as HTMLElement;
            if (container) {
                container.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
    }

    validateForm(prereq: any): boolean {

        if(prereq.optional){
            this.$set(prereq, 'invalid', false);
            return true;    
        }

    const requiredQuestions = (prereq.requiredFormQuestions || '')
        .split(',')
        .filter((x: string) => x)
        .map(Number);

    const answeredQuestionIds = (prereq.formAnswerList || [])
        .map((x: any) => Number(x.questionId));

    // Si hay preguntas requeridas y no hay respuestas
    const missingRequired =
        requiredQuestions.length > 0 &&
        (
            answeredQuestionIds.length === 0 ||
            requiredQuestions.some(
                (questionId: number) =>
                    !answeredQuestionIds.includes(questionId)
            )
        );

    this.$set(prereq, 'invalid', missingRequired);

    return !missingRequired;
}

    get years(): number[] {
        const currentYear = moment().year();
        return Array.from({ length: 121 }, (_, i) => currentYear - i);
    }

    get daysInMonth(): number {
        if (!this.dobParts.month || !this.dobParts.year) return 31;
        return new Date(Number(this.dobParts.year), Number(this.dobParts.month), 0).getDate();
    }

    updateDob(): void {
        const { day, month, year } = this.dobParts;
        if (day && month && year) {
            const formattedMonth = month.toString().padStart(2, '0');
            const formattedDay = day.toString().padStart(2, '0');
            this.appt.main.patient.birth.date = `${year}-${formattedMonth}-${formattedDay}`;
        }
    }

    resetForm() {

        this.appt = this.defaultAppt();
        this.appt.main.calendarId = this.calendar["id"];
        this.appt.main.date = this.getNextAvailableDate();
        this.submitted = false;
        this.dobParts = { day: "", month: "", year: "" };
        this.selectedType.description = null;
    }

    onReasonChange(): void {
        const selectedId = this.appt.main.reasonId;

        if (!selectedId) return;

        const selectedType = this.requestTypes.find(t => t.id === selectedId);
        this.selectedType = selectedType;
        if (selectedType) {

            this.appt.main.typeId = selectedType.apptTypeId;
             if(!selectedType.apptDuration){
              selectedType.apptDuration = this.calendar["apptDuration"];
             }
            this.appt.main.duration = selectedType.apptDuration;
            if(selectedType.defaultStatusId){
              this.appt.main.statusId = selectedType.defaultStatusId;
            }else if (this.calendar["autoApprove"]) {
                this.appt.main.statusId = "2";
            }else{
               this.appt.main.statusId = "1"; 
            }
            this.getPreReqs();

            this.loadTimeSlots();
        }
    }

    addPrerequisiteFiles(event: any, index: number, typeId: string): void {
        const file = event.target.files[0];
        if (typeId === "PIC") {
            if (!this.isImage(file)) {
                this.$set(this.appt.prereqs.list[index], 'fileName', file.name);
                this.$set(this.appt.prereqs.list[index], 'invalid', true);
                return;
            }

        }

        if (file) {

            this.$set(this.appt.prereqs.list[index], 'fileName', file.name);
            this.$set(this.appt.prereqs.list[index], 'invalid', false);
            this.$set(this.appt.prereqs.list[index], 'hasFile', true);
            this.$set(this.appt.prereqs.list[index], 'fileObject', file);
            this.$set(this.appt.prereqs.list[index], 'invalid', false);
        }
    }

    triggerFileUpload(index: number): void {

        const refName = 'fileInput' + index;
        const inputs = this.$refs[refName] as any;
        const fileInput = Array.isArray(inputs) ? inputs[0] : inputs;

        if (fileInput) {
            fileInput.click();
        }
    }

    isImage(file) {
        if (!file) return false;
        return file.type.startsWith("image/");
    }

    answersPercent(answered: number, questions: number): number {
        return Math.round((answered / questions) * 100);
    }

    async openForm(prereq: any, wizard: boolean) {

        console.log(prereq);
        this.prereqForm.prereq = prereq;
        this.prereqForm.form = {
            id: prereq.formId,
            name: prereq.name,
            hasAnswers: false,
        };
        this.$store.commit("main/SET_LOADING", true);
        try {
            const { formId } = prereq;
            this.prereqForm.questions = await this.$store.dispatch(
                "schedule/getRequestApptFormQuestions",
                {
                    formId,
                }
            );
            

            const formAnswers = prereq?.formAnswerList || [];

this.prereqForm.questions.forEach((q) => {

    // Buscar respuesta guardada
    const existingAnswer = formAnswers.find(
        a => a.questionId === q.id
    );

    // Si existe respuesta previa, usarla
    if (existingAnswer?.answer) {
        q.answer.value = existingAnswer.answer;
        return;
    }

    // Si ya tiene valor o no tiene apptField, no hacer nada
    if (q.answer.value || !q.options?.apptField) {
        return;
    }

    const apptField = q.options.apptField;

    let value = '';

    switch (apptField) {

        // APPOINTMENT
        case "APPT_PROVIDER":
            value = this.doctor.name;
            break;

        case "APPT_DATE":
            value =  this.appt?.main?.date ?? '';
            break;

        case "APPT_TIME":
            value = this.appt.main.time;
            break;

        // PATIENT
        /*
        case "PATIENT_ID":
            value = this.appt.main.patient.id;
            break;
*/
        case "PATIENT_FIRST_NAME":
            value = this.appt.main.patient.firstName;
            break;

        case "PATIENT_LAST_NAME":
            value = this.appt.main.patient.lastName;
            break;

        case "PATIENT_LAST_NAME_2":
            value = this.appt.main.patient.lastName2 || '';
            break;

        case "PATIENT_FULL_NAME":
            value = `${this.appt.main.patient.lastName}, ${this.appt.main.patient.firstName}`;
            break;

        case "PATIENT_BIRTHDATE":
            value = this.appt.main.patient.birth.date;
            break;

        case "PATIENT_MEMBER_ID":
            value = this.appt.main.patient.insurer.memberId;
            break;

        case "PATIENT_EMAIL":
            value = this.appt.main.patient.email;
            break;

        case "PATIENT_PHONE":
            value = this.appt.main.patient.phone;
            break;
    }

    q.answer.value = value;
});

            /*
            //set default values
            this.prereqForm.questions.forEach((q) => {
                if (!q.answer.value && q.options && q.options.apptField) {
                    const {
                        apptField
                    } = q.options;
                    const {
                        answer
                    } = q;
                    switch (apptField) {
                        case "APPT_PROVIDER":
                            answer.value = this.doctor.name;
                            break;
                        case "APPT_DATE":
                            answer.value = this.appt.main.date;
                            break;
                        case "APPT_TIME":
                            answer.value = this.appt.main.time;
                            break;
                        // PATIENT
                        case "PATIENT_ID":
                            answer.value = this.appt.main.patient.id;
                            break;
                        case "PATIENT_FIRST_NAME":
                            answer.value = this.appt.main.patient.firstName;
                            break;
                        case "PATIENT_LAST_NAME":
                            answer.value = this.appt.main.patient.lastName;
                            break;
                        case "PATIENT_LAST_NAME_2":
                            answer.value = this.appt.main.patient.lastName2 ? this.appt.main.patient.lastName2 : '';
                            break;
                        case "PATIENT_FULL_NAME":
                            answer.value = this.appt.main.patient.lastName + ", " + this.appt.main.patient.firstName;
                            break;
                        case "PATIENT_BIRTHDATE":
                            answer.value = this.appt.main.patient.birth.date;
                            break;
                        case "PATIENT_MEMBER_ID":
                            answer.value = this.appt.main.patient.insurer.memberId;
                            break;
                        case "PATIENT_EMAIL":
                            answer.value = this.appt.main.patient.email;
                            break;
                        case "PATIENT_PHONE":
                            answer.value = this.appt.main.patient.phone;
                            break;

                    }
                }
            });

            */

        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
        this.$modal.show("form-viewer");
    }

    async saveFormAnswers(answers) {
        this.$store.commit("main/SET_LOADING", true);
        try {
            const formId = this.prereqForm.form.id;
            this.$set(this.prereqForm.prereq, 'formAnswerList', answers);
            this.$set(this.prereqForm.prereq, 'formAnswers', answers.length);

            this.validateForm(this.prereqForm.prereq);

            /*
              const isValid = this.validateForm(this.prereqForm.prereq);

            if(isValid){
                this.$set(this.prereqForm.prereq, 'invalid', false);
            }
          */
        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }

    get visibleTimeSlots() {
        return this.timeSlots.slice(0, this.slotsLimit);
    }

    showMoreSlots(): void {
        this.slotsLimit += 5;
    }

    getLogoURL(id) {
        return process.env.VUE_APP_ROOT_API + "/schedule/wmpc/content/file/" + id;
    }

    get currentLang(): string {
        return this.$i18n.locale.toUpperCase();
    }

    get nextLang(): string {
        return this.$i18n.locale === 'en' ? 'ES' : 'EN';
    }

    toggleLanguage(): void {

        const newLang = this.$i18n.locale === 'en' ? 'es' : 'en';
        this.$i18n.locale = newLang;
        this.appt.main.lang = this.currentLang;
    }


    get shouldShow(): boolean {
        if (!this.timeSlots || !this.sessions) return false;

        return (
    (this.calendar["showTimes"] && !this.timeSlots?.length) ||
    (this.calendar["showSession"] && !this.sessions?.length)
);

    }


    /*   isDisabledDate(ymd, date) {
      const rules = this.calendar["dates"];
      if (!rules?.length) return false;
    
      const weekday = moment(date).format("ddd").toUpperCase();
    
      const exact = rules.find(r => r.date === ymd);
      if (exact) return exact.disabled;
    
      const byDay = rules.find(r => r.date === "1900-01-01" && r.weekday === weekday);
      if (byDay) return byDay.disabled;
    
      return true;
    } */

    isDisabledDate(ymd, date) {
        const rules = this.calendar["dates"];
        const maxDays = this.calendar["apptRequestMaxDays"];

        if (maxDays > 0) {
            const today = moment().startOf("day");
            const limit = moment().add(maxDays, "days").endOf("day");

            const current = moment(date);

            if (current.isBetween(today, limit, null, "[]")) {
                return true;
            }
        }

        if (!rules?.length) return false;

        const weekday = moment(date).format("ddd").toUpperCase();

        const exact = rules.find(r => r.date === ymd);
        if (exact) return exact.disabled;

        const byDay = rules.find(r => r.date === "1900-01-01" && r.weekday === weekday);
        if (byDay) return byDay.disabled;

        return true;
    }

    getNextAvailableDate(): string | null {
        const maxSearchDays = 60; 

        let current = moment(this.today).startOf("day");

        for (let i = 0; i < maxSearchDays; i++) {
            const ymd = current.format("YYYY-MM-DD");

            const isDisabled = this.isDisabledDate(ymd, current.toDate());

            if (!isDisabled) {
                return ymd;
            }

            current.add(1, "day");
        }

        return null; 
    }

    parseJSON(value) {
        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            } catch {
                return {};
            }
        }
        return value || {};
    }


    mounted() {
        this.loadAgreement();
        this.getCalendar();
    }
}
